import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'pnx-texteditor',
    templateUrl: './texteditor.control.html',
    styleUrls: ['./texteditor.control.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TextEditorControl), multi: true }
    ]
})
export class TextEditorControl implements OnInit {

    @Input('value') _value;
    @Output() onChange: EventEmitter<string> = new EventEmitter<string>();

    txtContent: string;

    oDoc: any;
    sDefTxt: any;

    constructor() { }

    ngOnInit() {
        this.initDoc();
    }

    ngAfterViewInit() { }

    initDoc() {
        this.oDoc = document.getElementById("txtEditor");
        this.sDefTxt = this.oDoc.innerHTML;
    }

    formatDoc(sCmd: any, sValue?: any) {
        document.execCommand(sCmd, false, sValue);
        this.onChange.emit(this.oDoc.innerHTML);
        this.value = this.oDoc.innerHTML;
        this.oDoc.focus();
    }

    enterUrl() {
        var sLnk = prompt('Write the URL here', 'http:\/\/');
        if (sLnk && sLnk != '' && sLnk != 'http://')
        { this.formatDoc('createlink', sLnk) }
    }

    clearContent() {
        if (confirm('Are you sure?'))
        { this.oDoc.innerHTML = this.sDefTxt };
    }

    printDoc() {
        var oPrntWin = window.open("", "_blank", "width=450,height=470,left=400,top=100,menubar=yes,toolbar=no,location=no,scrollbars=yes");
        oPrntWin.document.open();
        oPrntWin.document.write("<!doctype html><html><head><title>Print<\/title><\/head><body onload=\"print();\">" + this.oDoc.innerHTML + "<\/body><\/html>");
        oPrntWin.document.close();
    }

    onChangeCb: (_: any) => void = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.onChangeCb(val);
    }

    writeValue(value): void {
        this.value = value;
        this.txtContent = this.value;
    }

    registerOnChange(fn: any): void {
        this.onChangeCb = fn;
    }

    registerOnTouched(fn: any): void { }

    setDisabledState(isDisabled: boolean): void { }

}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/texteditor.control.ts